import { GenericError } from '../../../errors/shared/genericError.js';
import { AbortError, UnknownError } from '../../../errors/shared/base.js';
import { HttpTimeoutError } from '../../../errors/shared/http.js';
import { Ok, Err } from '../../../result/shared/result.js';
import { abortSignalAny } from '../../../utils/shared/abort.js';
import { BASE_CLIENT_NAMESPACE, DEFAULT_HTTP_TIMEOUT } from '../const.js';
import { HttpResponse } from '../Response/Response.js';
import { urlToLog } from '../url.js';

const NAMESPACE = `${BASE_CLIENT_NAMESPACE}.fetch-request`;
async function fetchRequest({ url, method, headers, withCredentials, body, responseContentType, timeout = DEFAULT_HTTP_TIMEOUT, requestServerName, signal: userSignal, keepalive, }) {
    const credentials = withCredentials ? 'include' : 'same-origin';
    const timeoutAC = new AbortController();
    const signal = userSignal ? (AbortSignal.any || abortSignalAny)([userSignal, timeoutAC.signal]) : timeoutAC.signal;
    const fetchRequestInit = {
        method,
        headers: Array.from(headers || []),
        credentials,
        signal,
        keepalive,
    };
    if (method === 'POST') {
        fetchRequestInit.body = body;
    }
    const timer = setTimeout(() => {
        setTimeout(() => timeoutAC.abort(new HttpTimeoutError({
            timeout,
            url: urlToLog(url).toString(),
            domain: `${NAMESPACE}.timeout.${requestServerName}`,
        })), 1);
    }, timeout);
    const req = new Request(url, fetchRequestInit);
    try {
        const res = await fetch(req);
        const httpResponse = new HttpResponse(res, {
            requestServerName,
            timeout,
            responseContentType,
        });
        const bodyResult = await httpResponse.compileBody();
        if (bodyResult.isErr()) {
            return bodyResult;
        }
        return Ok(httpResponse);
    }
    catch (error) {
        if (GenericError.isLike(error)) {
            return Err(error);
        }
        if (error instanceof DOMException && error.name === 'AbortError') {
            return Err(new AbortError({
                message: error.message,
                domain: `${NAMESPACE}.abort.${requestServerName}`,
                details: error,
            }));
        }
        return Err(new UnknownError({
            message: `Unknown Fetch request exception ${urlToLog(url).toString()}`,
            domain: `${NAMESPACE}.unknown-error.${requestServerName}`,
            details: error,
        }));
    }
    finally {
        clearTimeout(timer);
    }
}

export { fetchRequest };
//# sourceMappingURL=fetchRequest.js.map
